<!--
 * @Description: 申请详情弹窗
 * @Author: yeqing
 * @Date: 2021-9-7 17:35:30
 * @LastEditTime:
 * @LastEditors:
-->
<template>
  <a-modal :visible="isVisible" title="申请详情" :footer="null" @cancel="handleCancel" class="apply-detail-model" width="630px">
    <div>
      <div class="item-box cr-flex">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">发票类型:</label>
        <div class="cr-text-grey-2">增值税普通电子发票</div>
      </div>
      <div class="item-box cr-flex">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">发票内容:</label>
        <div class="cr-text-grey-2">{{ detailInfo.content }}</div>
      </div>
      <div class="item-box cr-flex">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">发票金额:</label>
        <div class="cr-text-black-2 money">
          <span class="cr-text-amount">{{ detailInfo.amount && detailInfo.amount.toFixed(2) }}</span
          >元
        </div>
      </div>
      <div class="item-box cr-flex">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">发票抬头:</label>
        <div class="cr-text-grey-2">{{ detailInfo.title }}</div>
      </div>
      <div class="item-box cr-flex">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">纳税号:</label>
        <div class="cr-text-grey-2">{{ detailInfo.identifyNo }}</div>
      </div>
      <div class="item-box cr-flex" v-show="detailInfo.address">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">公司地址:</label>
        <div class="cr-text-grey-2">{{ detailInfo.address }}</div>
      </div>
      <div class="item-box cr-flex" v-show="detailInfo.mobile">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">公司电话:</label>
        <div class="cr-text-grey-2">{{ detailInfo.mobile }}</div>
      </div>
      <div class="item-box cr-flex" v-show="detailInfo.accountBank">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">开户银行:</label>
        <div class="cr-text-grey-2">{{ detailInfo.accountBank }}</div>
      </div>
      <div class="item-box cr-flex" v-show="detailInfo.accountNo">
        <label class="cr-text-lt cr-mr-3 cr-text-black-2">开户账号:</label>
        <div class="cr-text-grey-2">{{ detailInfo.accountNo }}</div>
      </div>
    </div>
    <!-- 关联案件列表 -->
    <div class="cr-text-black-2 title">关联的案件</div>
    <a-table :columns="columns" :pagination="false" :row-key="(record) => record.no" :data-source="getData" :locale="{ emptyText: tebleEmptyText }"> </a-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '申请编号',
    dataIndex: 'no'
  },
  {
    title: '金额(元)',
    dataIndex: 'amount'
  },
  {
    title: '支付时间/方式',
    dataIndex: 'patMethod'
  }
]
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns,
      data: [],
      tebleEmptyText: <cr-nodata dataHeight="130px" />
    }
  },
  computed: {
    getData() {
      let list = []
      if (this.detailInfo && this.detailInfo.excelVo) {
        this.detailInfo.excelVo.data.map((item) => {
          list.push({
            no: item[0],
            amount: item[1],
            patMethod: item[2]
          })
        })
      }
      return list
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:isVisible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.apply-detail-model {
  .item-box {
    height: 14px;
    margin-bottom: 24px;
    label {
      width: 70px;
    }
    .money {
      span {
        margin-right: 6px;
        font-weight: bold;
      }
    }
  }
  .title {
    font-weight: bold;
    margin: 40px 0 16px 0;
  }
  ::v-deep.ant-table-thead > tr > th,
  ::v-deep.ant-table-tbody > tr > td {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
  }
  ::v-deep.ant-table-thead > tr > th {
    font-weight: bold;
    color: @cr-text-3;
  }
  ::v-deep.ant-table-tbody > tr > td {
    color: @cr-text-6;
  }
  ::v-deep.ant-modal-body {
    max-height: 700px;
    overflow-y: auto;
  }
  ::v-deep.ant-table-placeholder {
    border-bottom: none;
  }
}
</style>
